import React, { useEffect, useState } from 'react'
import { ITransactionModal } from './TransactionsApp'
import { IItemLocation, SingleCurrentItemLocation } from '../items/CurrentItemLocation'
import { Skeleton } from '@mui/material'
import WarehousesApp from '../warehouses/WarehousesApp'
import SectionsApp from '../sections/SectionsApp'
import LocationsApp from '../locations/LocationsApp'
import UsersApp from '../user/UsersApp'

interface IProps {
    transcation: ITransactionModal,
    showOrigin?: boolean
}

export default function GenerateTransactionDestination(props: IProps) {

    const { showOrigin } = props

    const [locations, setLocations] = useState<Array<IItemLocation>>([])
    const [loading, setLoading] = useState<boolean>(false)

    const { original_warehouse_title, original_location_title, original_section_title, type, original_section_id, original_warehouse_id, warehouse_title, section_title, location_title, warehouse_id, section_id, location_id, user_id, user_full_name, original_user_title, original_user_id, created_by_name, original_location_id } = props.transcation

    useEffect(() => {

        if (showOrigin){

            if (original_warehouse_id){
                setLocations([
                    {
                        type: "warehouse",
                        label: original_warehouse_title,
                        id: original_warehouse_id
                    },
                    {
                        type: "section",
                        label: original_section_title,
                        id: original_section_id
                    }
                ])
            }

            if (original_location_id){
                setLocations([
                    {
                        type: "location",
                        label: original_location_title,
                        id: original_location_id
                    },
                ])
            }

            if (original_user_id){
                setLocations([
                    {
                        type: "user",
                        label: original_user_title,
                        id: original_user_id
                    },
                ])
            }
        }else{

            switch(type){

                case "to-warehouse":
                    if (warehouse_id){
                        setLocations([
                            {
                                type: "warehouse",
                                label: warehouse_title,
                                id: warehouse_id
                            },
                            {
                                type: "section",
                                label: section_title,
                                id: section_id
                            }
                        ])
                    }
                    break

                case "to-section":
                    if (section_id){
                        setLocations([
                            {
                                type: "warehouse",
                                label: warehouse_title,
                                id: warehouse_id
                            },
                            {
                                type: "section",
                                label: section_title,
                                id: section_id
                            }
                        ])
                    }
                    break

                case "to-location":
                    if (location_id){
                        setLocations([
                            {
                                type: "location",
                                label: location_title,
                                id: location_id
                            },
                        ])
                    }
                    break

                case "with-user":
                    setLocations([
                        {
                            type: "user",
                            label: user_full_name,
                            id: user_id
                        },
                    ])
                    break

            }
        }

        if (type == "stock-adjustment" && !showOrigin){
            if (warehouse_id){
                setLocations([
                    {
                        type: "warehouse",
                        label: warehouse_title,
                        id: warehouse_id
                    },
                    {
                        type: "section",
                        label: section_title,
                        id: section_id
                    }
                ])
            }

            if (original_location_id){
                setLocations([
                    {
                        type: "location",
                        label: location_title,
                        id: location_id
                    },
                ])
            }

            if (original_user_id){
                setLocations([
                    {
                        type: "user",
                        label: user_full_name,
                        id: user_id
                    },
                ])
            }
        }

    }, [props.transcation])

    // if (props.transcation.action == "new-item"){
    //     return <p>-</p>
    // }

    return(
        <div className="item-current-location">
            <div className="content-of-item-current-location">
                {loading ? <div style={{ display: "flex", gap: 5 }}><Skeleton variant="text" width={100} /><Skeleton variant="text" width={100} /></div> : locations.length > 0 ? locations.map((location, index) => <SingleCurrentItemLocation location={location} key={index} addArrow={locations.length !== (index + 1)} />) : <p>-</p>}
            </div>
        </div>
    )
}